/**
 * Formats seconds into MM:SS string.
 *
 * @param duration - number of seconds
 * @returns formatted string like "03:45"
 */
export function formatDuration(duration?: number): string {
  if (typeof duration !== 'number' || isNaN(duration)) {
    return '00:00';
  }

  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;

  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(seconds).padStart(2, '0');

  return `${paddedMinutes}:${paddedSeconds}`;
}
// Example usage:
// console.log(formatDuration(140)); // "02:20"
// console.log(formatDuration(69000)); // "19:15"
// console.log(formatDuration(1200000)); // "333:20"
